import React, { PureComponent } from 'react';
import {
  placeholder,
  Container,
  Image,
  LoadingThumb,
  FallbackImage,
} from './style';

const fetchImage = src =>
  new Promise((res, rej) => {
    const image = new window.Image();
    image.src = src;
    image.onload = res;
    image.onabort = rej;
    image.onerror = rej;
  });

const IntrinsicPlaceholder = ({ aspectRatio, children, ...rest }) => {
  const placeholderStyle = placeholder(aspectRatio);
  return (
    <div className={placeholderStyle} {...rest}>
      {children}
    </div>
  );
};

class LazyImage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      status: null,
      thumb: null,
    };

    this._mounted = false;
  }

  async preload() {
    const { src, thumbnail } = this.props;

    if (thumbnail) {
      try {
        await fetchImage(thumbnail);
        this.onImageLoaded('thumb');
      } catch (e) {
        this.onImageError('thumb');
      }
    }

    try {
      await fetchImage(src);
      this.onImageLoaded('status');
    } catch (e) {
      this.onImageError('status');
    }
  }

  onImageLoaded(image) {
    if (!this._mounted) return;
    this.setState({
      [image]: 'loaded',
    });
  }

  onImageError(image) {
    if (!this._mounted) return;
    this.setState({
      [image]: 'error',
    });
  }

  componentDidMount() {
    this._mounted = true;
    this.preload();
  }

  componentWillUnmount() {
    this._mounted = false;
  }

  render() {
    const { src, aspectRatio, ...rest } = this.props;
    const { status } = this.state;
    return (
      <IntrinsicPlaceholder aspectRatio={aspectRatio} {...rest}>
        <Container isStillLoading={status === null}>
          {status !== 'loaded' && <LoadingThumb />}
          <Image src={src} isVisible={status === 'loaded'} />
          {status === 'error' && (
            <FallbackImage>Ich bin beim Fotograf. </FallbackImage>
          )}
        </Container>
      </IntrinsicPlaceholder>
    );
  }
}

export const LoadingImage = ({ aspectRatio }) => (
  <IntrinsicPlaceholder aspectRatio={aspectRatio}>
    <Container isStillLoading={true}>
      <LoadingThumb />
    </Container>
  </IntrinsicPlaceholder>
);

export default LazyImage;



// WEBPACK FOOTER //
// ./src/components/image/index.js